import {call, put, takeLatest, fork, all} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as PayAtHotelService from './../services/payAtHotelService';
import history from '../helpers/history';
import {PATHS} from '../constants/Define';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {
    setPayAtHotel as setPayAtHotelAction, setProfileTypes as setProfileTypeAction
} from './../actions/payAtHotelAction';

function* getPayAtHotel() {
    yield takeLatest(Types.GET_PAY_AT_HOTEL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PayAtHotelService.getPayAtHotel, action.filters);
        yield put(setPayAtHotelAction(result));
    }, errorHandlePayAtHotel(Types.PAY_AT_HOTEL_FAIL)))
}

function* getProfileType() {
    yield takeLatest(Types.GET_PROFILE_TYPE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PayAtHotelService.getProfileType, action.filters);
        yield put(setProfileTypeAction(result));
    }, errorHandlePayAtHotel(Types.PAY_AT_HOTEL_FAIL)))
}

function* updatePayAtHotel() {
    yield takeLatest(Types.PAY_AT_HOTEL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(PayAtHotelService.updatePayAtHotel, action.payAtHotel);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), "Pay at hotel");
        // yield put({ type: Types.PAY_AT_HOTEL_UPDATE_SUCCESS });
        // yield put(setPayAtHotelAction(result));
        history.push(PATHS.PAY_AT_HOTEL.path);
        history.go();
    }, errorHandlePayAtHotel(Types.PAY_AT_HOTEL_FAIL)))
}

function errorHandlePayAtHotel(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'payAtHotel');
}

export function* payAtHotelSaga() {
    yield all([
        fork(getPayAtHotel),
        fork(getProfileType),
        fork(updatePayAtHotel)
    ])
}
